export default "__VITE_ASSET__32d88463__"